module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA0klEQVRIS+2TPQ5BQRSFv9OyARoVm9BagMQSUNiF2IUCO1DoaVkElYYN0B55iZc8v294RIRp597zzZx7rnjz0Zv1+UGAbUsK/nlwYTyrPyA1tX+LrlpkOy9pF10mLbKdk7S/52tQTG3PgYGkUQyw3QTakqqvAFSAKdADhkAL6AI1SavMgKM1ZWAGlIB1iHjUd2JRWgRtR5AlULn38qTOQ4DUJTkWfBSwARqSFqGvPa+zHaVqLKl4bQZ1oA8UngUAW6AjaXIByCB6szVo0bKAvx9wAI61bhl2s6neAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon-download.png
// module id = BBFl
// module chunks = 4